module.exports = __webpack_public_path__ + "img/banner_1.4829f06f.jpg";